import './style.scss';

import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'reactstrap';

import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import NavigationTopRight from '../../components/navigation-top-right';

const KYC_URL = process.env.REACT_APP_MAYAR_KYC_URL;

const Verification = () => {
  const currentUser = useSelector(state => state.currentUser);

  const handleOpenKYC = () => {
    if (!KYC_URL) return;
    // KYC drives its own login via auth-v2 /authorize; with a warm Mayar IdP
    // session it signs in silently. Opened in a NEW TAB so www stays where it
    // is; the button in content.jsx is the fallback when the popup is blocked
    // (no user activation, e.g. a hard reload straight onto /verification).
    window.open(`${KYC_URL}/?from=mayar`, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    if (currentUser.role === 'user') {
      handleOpenKYC();
    } else {
      window.location.href = '/';
    }
  }, []);

  return (
    <PageWrap>
      <PageTitle className="d-none d-sm-block" breadcrumbs={{ '/': currentUser ? currentUser.name : '' }}>
        <Row className="mb-0">
          <Col md="6">
            <h1 className="mb-0">Verifikasi Akun</h1>
          </Col>
          <Col md="6" className="text-right">
            <NavigationTopRight />
          </Col>
        </Row>
      </PageTitle>
      <PageContent>
        <AsyncComponent component={() => import('./content')} />
      </PageContent>
    </PageWrap>
  );
};

export default Verification;
